import { ESaleType } from 'packages/api-models/common/json_query';
import { getTermsValue, setTerms } from './helpers';
import { TJsonQuery, NonEmptyArray } from './types';
import { setSaleTypes } from './setSaleTypes';
import { NEWBUILDING_SALE_TYPES } from 'shared/constants/saleTypeValues';

export const setNewbuildingSaleTypes = (jsonQuery: TJsonQuery) => (nextSaleTypes: NonEmptyArray<ESaleType> | null) => {
  const prevSaleTypes = getTermsValue('sost_type')(jsonQuery);

  if (prevSaleTypes && nextSaleTypes === null) {
    const filteredSaleTypes = prevSaleTypes.filter(saleType => !NEWBUILDING_SALE_TYPES.includes(saleType));

    return setTerms('sost_type')(jsonQuery)(filteredSaleTypes);
  }

  return setSaleTypes(jsonQuery)(nextSaleTypes);
};
